/**
 * Fonctions utilitaires pour le formatage des données
 */

/**
 * Formate une adresse en supprimant les éléments redondants
 * @param {string} address - L'adresse à formater
 * @returns {string} L'adresse formatée
 */
export const formatAddress = (address) => {
  if (!address) return '';
  
  // Supprimer ', France' à la fin si présent
  let formattedAddress = address.replace(/, France$/, '');
  
  // Supprimer le code postal et la ville s'ils sont répétés dans l'adresse
  // Exemple: "123 Rue de Paris, 75001 Paris, France" -> "123 Rue de Paris"
  const regex = /, \d{5} [^,]+$/;
  if (regex.test(formattedAddress)) {
    formattedAddress = formattedAddress.replace(regex, '');
  }
  
  return formattedAddress;
};

/**
 * Formate une date en format localisé
 * @param {string} dateString - La date au format ISO
 * @returns {string} La date formatée
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  return new Date(dateString).toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

/**
 * Vérifie si deux noms sont identiques (insensible à la casse)
 * @param {string} name1 - Premier nom
 * @param {string} name2 - Deuxième nom
 * @returns {boolean} Vrai si les noms sont identiques
 */
export const areNamesIdentical = (name1, name2) => {
  if (!name1 || !name2) return false;
  return name1.toLowerCase() === name2.toLowerCase();
};

/**
 * Retourne la classe CSS de background correspondant au statut de livraison
 * @param {string} status - Le statut de la livraison
 * @returns {string} La classe CSS
 */
export const getStatusBackgroundClass = (status) => {
  // Normaliser le statut au cas où il serait en minuscules
  const normalizedStatus = status?.toUpperCase();
  
  const backgroundMap = {
    'PLANNED': 'bg-blue-400',
    'DELIVERED': 'bg-green-400',
    'NOT DELIVERED': 'bg-red-400',
    'DO NOT DELIVER': 'bg-purple-400',
    'IN PROGRESS': 'bg-orange-400'
  };
  
  return backgroundMap[normalizedStatus] || 'bg-gray-600';
}; 